import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';

import { AuthProvider } from '../src/auth/AuthContext';
import { theme } from './styles/theme';
import { GlobalStyle } from './styles/GlobalStyle';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollTop';

import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import RoleRoute from './components/RoleRoute';

/* PAGES */
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Verify from './pages/Verify';
import AuthCallback from './pages/AuthCallback';
import WelcomeOnboarding from './pages/WelcomeOnboarding';
import PasswordAccess from './pages/PasswordAccess';
import AdminProperties from './pages/AdminProperties';
import AdminHome from './pages/AdminHome';

import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import CuyoExplorer from './pages/CuyoExplorer';
import Vacacionales from './pages/Vacacionales';
import CuyoEditorial from './pages/CuyoEditorial';
import CuyoArticle from './pages/CuyoArticle';
import Alerts from './pages/Alerts';
import LegalCenter from './pages/LegalCenter';
import LegalDocument from './pages/LegalDocument';
import CookieNotice from './components/CookieNotice';
import SeoManager from './components/SeoManager';
import InstallNido from './components/InstallNido';
import GuestWelcomePrompt from './components/GuestWelcomePrompt';

import Buscar from './pages/Buscar';
import Departamento from './pages/Departamento';

import GranMendoza from './components/GranMendoza';
import Capital from './components/Capital';
import Barrio from './components/Barrio';

import ClientDashboard from './pages/ClientDashboard';
import Plans from './pages/Plans';
import BillingCheckout from './pages/BillingCheckout';
import ProfessionalConversion from './pages/ProfessionalConversion';
import MySubscription from './pages/MySubscription';
import BillingHistoryPage from './pages/BillingHistoryPage';
import PropertyIntegrations from './pages/PropertyIntegrations';
import PaymentStatus from './pages/PaymentStatus';
import PerfilAjustes from './pages/miPerfil/PerfilAjustes';
import MisPublicaciones from './pages/miPerfil/MisPublicaciones';
import Mensajes from './pages/miPerfil/Mensajes';
import Favorites from './pages/miPerfil/Favorites';

import PublishProperty from './pages/PublishProperty';
import PublishGuide from './pages/PublishGuide';
import EditProperty from './pages/EditProperty';

import TestUpload from './pages/TestUpload';

import Desarrollos from './desarrollos/pages/Desarrollos';
import DesarrollosCategoria from './desarrollos/pages/DesarrollosCategoria';
import DesarrolloDetalle from './desarrollos/pages/DesarrolloDetalle';
import ProjectWizard from './desarrollos/pages/ProjectWizard';
import DeveloperDashboard from './desarrollos/pages/DeveloperDashboard';

import PublicProfile from "../src/pages/PublicProfile.js";
import AboutNido from './pages/AboutNido';
import QuintaSeccionEditorial from './pages/QuintaSeccionEditorial';
import ZoneEditorial from './pages/ZoneEditorial';
import EditorialCampaignAdmin from './pages/EditorialCampaignAdmin';
import AdminProfiles from './pages/AdminProfiles';
import AdminOffers from './pages/AdminOffers';
import PerfilOpiniones from './pages/miPerfil/PerfilOpiniones';
import NotFound from './pages/NotFound';
import SearchLanding from './pages/SearchLanding';

 


function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <AuthProvider>
        <BrowserRouter>
        <SeoManager/>
        <ScrollToTop/>
        <SkipLink href="#contenido-principal">Saltar al contenido principal</SkipLink>
        <Header/>
        <GuestWelcomePrompt/>
          <Routes>

            {/* 🌍 LAYOUT GENERAL */}
            <Route element={<Layout />}>

              {/* 🔓 PÚBLICAS */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify" element={<Verify />} />
              <Route path="/verify/:token" element={<Verify />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/forgot-password" element={<PasswordAccess />} />
              <Route path="/reset-password" element={<PasswordAccess reset />} />

              <Route path="/properties" element={<Properties />} />
              <Route path="/properties/:id" element={<PropertyDetail />} />
              <Route path="/explorar-cuyo" element={<CuyoExplorer />} />
              <Route path="/vacaciones" element={<Vacacionales />} />
              <Route path="/vivir-cuyo" element={<CuyoEditorial />} />
              <Route path="/vivir-cuyo/:slug" element={<CuyoArticle />} />
              <Route path="/quienes-somos" element={<AboutNido />} />
              <Route path="/zonas/mendoza/quinta-seccion" element={<QuintaSeccionEditorial />} />
              <Route path="/zonas/:zoneSlug" element={<ZoneEditorial />} />
              <Route path="/legal" element={<LegalCenter />} />
              <Route path="/legal/:document" element={<LegalDocument />} />
              <Route path="/pago/:status" element={<PaymentStatus />} />

              <Route path="/testimagen" element={<TestUpload />} />

              {/* 🔎 BUSCAR – FLUJO PRINCIPAL (GUIADO) */}
              <Route path="/buscar" element={<Buscar />} />

              <Route path="/propiedades/:province" element={<SearchLanding />} />
              <Route path="/alquileres/:province" element={<SearchLanding />} />
              <Route path="/casas-en-venta/:province" element={<SearchLanding />} />

              <Route path="/buscar/gran-mendoza" element={<GranMendoza />} />
              <Route
                path="/buscar/gran-mendoza/mendoza-capital"
                element={<Capital />}
              />
              <Route
                path="/buscar/gran-mendoza/mendoza-capital/:barrio"
                element={<Barrio />}
              />
              <Route
                path="/buscar/gran-mendoza/:departamento"
                element={<Departamento />}
              />

              {/* 🔎 BUSCAR – FLUJO GENÉRICO (fallback / futuro) */}
              <Route path="/buscar/:departamento" element={<Departamento />} />
              <Route
                path="/buscar/:departamento/:barrio"
                element={<Barrio />}
              />

              <Route path="/:operation/:type/:department" element={<Properties />} />
<Route path="/:operation/:type/:department/:neighborhood" element={<Properties />} />

 <Route path="/perfil/:id" element={<PublicProfile />} />

              <Route path="/desarrollos" element={<Desarrollos />} />
              <Route path="/desarrollos/:categoria" element={<DesarrollosCategoria />} />
              <Route path="/desarrollo/:id" element={<DesarrolloDetalle />} />

              {/* 🔐 PRIVADAS */}
              <Route element={<PrivateRoute><Outlet /></PrivateRoute>}>
              <Route path="/publicar/guia" element={<RoleRoute allowedRoles={['CLIENT']}><PublishGuide /></RoleRoute>} />
              <Route path="/admin/editorial" element={<RoleRoute allowedRoles={['ADMIN']}><EditorialCampaignAdmin /></RoleRoute>} />
              <Route path="/admin" element={<RoleRoute allowedRoles={['ADMIN']}><AdminHome /></RoleRoute>} />
              <Route path="/admin/perfiles" element={<RoleRoute allowedRoles={['ADMIN']}><AdminProfiles /></RoleRoute>} />
              <Route path="/admin/publicaciones" element={<RoleRoute allowedRoles={['ADMIN']}><AdminProperties /></RoleRoute>} />
              <Route path="/admin/ofertas" element={<RoleRoute allowedRoles={['ADMIN']}><AdminOffers /></RoleRoute>} />
              <Route path="/welcome" element={<WelcomeOnboarding />} />
              <Route path="/favoritos" element={<Favorites />} />
              <Route path="/mi-perfil/opiniones" element={<PerfilOpiniones />} />
              <Route path="/alertas" element={<Alerts />} />
              <Route path="/desarrollador" element={<DeveloperDashboard />} />
              <Route path="/desarrollador/nuevo" element={<ProjectWizard />} />
              <Route path="/desarrollador/:id/editar" element={<ProjectWizard />} />

               <Route
    path="/client/perfil"
    element={
      <RoleRoute allowedRoles={['CLIENT', 'PROFESSIONAL']}>
        <PerfilAjustes />
      </RoleRoute>
    }
  />

  <Route path="/mensajes" element={<Mensajes />} />
<Route
  path="/mensajes/:id"
  element={<Mensajes />}
/>
      

                <Route
                  path="/client"
                  element={
                    <RoleRoute allowedRoles={['CLIENT', 'PROFESSIONAL']}>
                      <ClientDashboard />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/client/planes"
                  element={
                    <RoleRoute allowedRoles={['CLIENT', 'PROFESSIONAL']}>
                      <Plans />
                    </RoleRoute>
                  }
                />
                <Route path="/client/checkout/:planCode" element={<BillingCheckout />} />
                <Route path="/client/hacete-profesional" element={<ProfessionalConversion />} />
                <Route path="/client/suscripcion" element={<MySubscription />} />
                <Route path="/client/facturas" element={<BillingHistoryPage />} />
                <Route path="/client/integraciones" element={<RoleRoute allowedRoles={['PROFESSIONAL']}><PropertyIntegrations /></RoleRoute>} />

                <Route
  path="/mis-publicaciones"
  element={
    <PrivateRoute>
      <MisPublicaciones />
    </PrivateRoute>
  }
/>

                

                <Route
                  path="/publicar"
                  element={
                    <RoleRoute allowedRoles={['CLIENT', 'PROFESSIONAL']}>
                      <PublishProperty />
                    </RoleRoute>
                  }
                />

                <Route
                  path="/client/properties/:id/edit"
                  element={
                    <RoleRoute allowedRoles={['CLIENT', 'PROFESSIONAL']}>
                      <EditProperty />
                    </RoleRoute>
                  }
                />

              </Route>

              <Route path="*" element={<NotFound />} />

            </Route>

          </Routes>
<AppFooter />
<CookieNotice/>
<InstallNido/>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

const SkipLink = styled.a`
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 10000;
  padding: 12px 16px;
  color: #fff;
  background: #24353b;
  border: 2px solid #f2a33b;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 750;
  text-decoration: none;
  transform: translateY(-150%);
  transition: transform 160ms ease;

  &:focus {
    transform: translateY(0);
  }
`;
function AppFooter() {
  const { pathname } = useLocation();
  return pathname === '/publicar' ? null : <Footer />;
}
